export const BRAND_NAME = 'SplitSumo';
export const SITE_URL = 'https://splitsumo.com';
export const APP_URL =
  process.env.GATSBY_APP_URL ?? 'https://app.splitsumo.com';

// https://flatuicolors.com/palette/cn
export const palette = {
  body: '#f7f7f6',
  themeLightGray: '#f9f9f7',
  themePrimary: '#ff7f50',
  themeSecondary: '#ff6348',
  themeTertiary: '#cc4f3a',
  black: '#161412',
  'brand.50': '#fff4ed',
  'brand.100': '#ffe5d4',
  'brand.200': '#ffc7a8',
  'brand.300': '#ffa071',
  'brand.500': '#ff7f50',
  'brand.600': '#fe4711',
  'brand.700': '#c61c08',
  'brand.800': '#9d190f',
};

export const gaps = {
  section: {
    base: 8,
    lg: 10,
  },
};

export const SUPPORT_EMAIL = 'hello@splitsumo.com';

export const CONTAINER_SIZE = '6xl';

export const NAVBAR_HEIGHT = 60;

export const routes = {
  index: (anchor?: string) => `/${anchor ? `#${anchor}` : ''}`,
  termsOfUse: () => '/terms-of-use',
  privacyPolicy: () => '/privacy-policy',
  faq: (slug?: string) => `/faq${slug ? `/${slug}` : ''}`,
  legalNotice: () => '/legal-notice',
};
